import { z } from "zod";

/**
 * FeriasSchema
 */

export const FeriasSchema = z.object({
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),
  dataInicio: z.coerce.date(),
  dataTermino: z.coerce.date(),
});

/**
 * FeriasForm
 */

export type FeriasForm = z.infer<typeof FeriasSchema>;